import React from 'react'

import { CustomerInfo } from '@lyrahealth-inc/shared-app-logic/src/models/customer/Customer'

import styles from './requestPayment.module.scss'
import sessionResetDate from '../common/content/sessionResetDate'

const CancelledSessionsExceededModal = ({
  firstName,
  lastName,
  visitDate,
  company,
}: CancelledSessionsExceededModalProps) => {
  return (
    <div className={styles['modal-content']}>
      <h2 className={styles['main-header']}>Whoops! Invalid invoice</h2>
      <div>
        <p>
          We regret that your invoice for client <span className={styles.capitalize}>{firstName}</span>{' '}
          <span className={styles.capitalize}>{lastName}</span>, who did not show for the appointment (or cancelled
          within 24 hours) dated {visitDate}, cannot be paid by Lyra. The client has exceeded the number of
          cancellations allowed by the sponsoring employer (which, in some cases, is zero). Please contact your client
          to collect any payments owed to you.{' '}
          {sessionResetDate({ employer: company?.label, date: company?.session_count_starts_on })}
        </p>
      </div>
    </div>
  )
}

type CancelledSessionsExceededModalProps = {
  firstName: string
  lastName: string
  visitDate: string
  company?: CustomerInfo
}

export default CancelledSessionsExceededModal
